module.exports = __webpack_public_path__ + "header-img.png?569bd6350855ed61bfd7fbffa92d76d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-img.png
// module id = 164
// module chunks = 0